module.exports = __webpack_public_path__ + "img/CRT_Weapon-Sword-03.46938712.png";